module.exports = __webpack_public_path__ + "img/main-md.b5c99830.jpg";